import { toast } from "react-toastify";
import {
  fetchUpdateSOStart,
  fetchUpdateSOSuccess,
  fetchUpdateSOFailure,
} from "./reducer";
import { UPDATE_SO } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const updateSO =
  (jsonObj, orderId, itemId, setLoading, onSuccess, showToast = true) =>
  async (dispatch) => {
    dispatch(fetchUpdateSOStart());
    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        UPDATE_SO(orderId, itemId),
        "PUT",
        jsonObj
      );

      if (response?.error) {
        dispatch(fetchUpdateSOFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchUpdateSOSuccess(response));
        dispatch(setSuccessMessage(true));
        if (showToast) {
          toast.success(response.message);
        }
        if (onSuccess) {
          onSuccess();
        }
      }
    } catch (error) {
      dispatch(fetchUpdateSOFailure("Something went wrong"));
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };